import React, { useState, useEffect } from "react";
import useUpdateVesselInformation from "../Utils/useUpdateVesselInformation";
import useFetchVesselInformation from "../Utils/useFetchVesselInformation";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "react-toastify/dist/ReactToastify.css";
import "./updatevessel.css";

const UpdateVesselInformationForm = ({ vesselId }) => {
 


  const { mutate: updateVesselInformation, isLoading: isUpdating } = useUpdateVesselInformation();
  const { data: vesselInfo } = useFetchVesselInformation(vesselId);

  const [collapsedSections, setCollapsedSections] = useState({ vesselInformation: true });
  
  // States for form fields
  const [numberOfBerths, setNumberOfBerths] = useState("");
  const [deckSpace, setDeckSpace] = useState("");
  const [deckStrength, setDeckStrength] = useState("");
  const [classification, setClassification] = useState("");
  const [yearOfBuilt, setYearOfBuilt] = useState("");
  const [speed, setSpeed] = useState("");
  const [portOfRegistry, setPortOfRegistry] = useState("");
  const [callSign, setCallSign] = useState("");
  const [officialNumber, setOfficialNumber] = useState("");
  const [imoNumber, setImoNumber] = useState("");
  const [mmsiNumber, setMmsiNumber] = useState("");
  const [lengthOverall, setLengthOverall] = useState("");
  const [beamMoulded, setBeamMoulded] = useState("");
  const [draft, setDraft] = useState("");
  const [grossTonnage, setGrossTonnage] = useState("");
  const [cruisingSpeed, setCruisingSpeed] = useState("");
  const [range, setRange] = useState("");
  const [fuelCapacity, setFuelCapacity] = useState("");
  const [propulsion, setPropulsion] = useState("");
  const [generators, setGenerators] = useState("");
  const [waterCapacity, setWaterCapacity] = useState("");
  const [builder, setBuilder] = useState("");
  const [keelLaid, setKeelLaid] = useState("");
  const [bollardPull, setBollardPull] = useState("");
  const [bhp, setBhp] = useState("");
  const [trackable, setTrackable] = useState("true");
  const [numberOfPassengers, setNumberOfPassengers] = useState("");
  const [vesselType, setVesselType] = useState(""); // State for vessel type

  // Keep track of changed fields
  const [changedFields, setChangedFields] = useState({});

  useEffect(() => {
    if (vesselInfo && vesselInfo.data && vesselInfo.data.vesselInformation) {
      const info = vesselInfo.data.vesselInformation;
      setNumberOfBerths(info.numberOfBerths || "");
      setDeckSpace(info.deckSpace || "");
      setDeckStrength(info.deckStrength || "");
      setClassification(info.classification || "");
      setYearOfBuilt(info.yearOfBuilt || "");
      setSpeed(info.speed || "");
      setPortOfRegistry(info.portOfRegistry || "");
      setCallSign(info.callSign || "");
      setOfficialNumber(info.officialNumber || "");
      setImoNumber(info.imoNumber || "");
      setMmsiNumber(info.mmsiNumber || "");
      setLengthOverall(info.lengthOverall || "");
      setBeamMoulded(info.beamMoulded || "");
      setDraft(info.draft || "");
      setGrossTonnage(info.grossTonnage || "");
      setCruisingSpeed(info.cruisingSpeed || "");
      setRange(info.range || "");
      setFuelCapacity(info.fuelCapacity || "");
      setPropulsion(info.propulsion || "");
      setGenerators(info.generators || "");
      setWaterCapacity(info.waterCapacity || "");
      setBuilder(info.builder || "");
      setKeelLaid(info.keelLaid || "");
      setBollardPull(info.bollardPull || "");
      setBhp(info.bhp || "");
      setTrackable(info.trackable ? "true" : "false");
      setNumberOfPassengers(info.numberOfPassengers || "");
      setVesselType(info.vesselType || ""); // Set vessel type
    }
  }, [vesselInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update the changed field state when an input changes
    setChangedFields((prev) => ({
      ...prev,
      [name]: value,
    }));

    switch (name) {
      case "numberOfBerths": setNumberOfBerths(value); break;
      case "deckSpace": setDeckSpace(value); break;
      case "deckStrength": setDeckStrength(value); break;
      case "classification": setClassification(value); break;
      case "yearOfBuilt": setYearOfBuilt(value); break;
      case "speed": setSpeed(value); break;
      case "portOfRegistry": setPortOfRegistry(value); break;
      case "callSign": setCallSign(value); break;
      case "officialNumber": setOfficialNumber(value); break;
      case "imoNumber": setImoNumber(value); break;
      case "mmsiNumber": setMmsiNumber(value); break;
      case "lengthOverall": setLengthOverall(value); break;
      case "beamMoulded": setBeamMoulded(value); break;
      case "draft": setDraft(value); break;
      case "grossTonnage": setGrossTonnage(value); break;
      case "cruisingSpeed": setCruisingSpeed(value); break;
      case "range": setRange(value); break;
      case "fuelCapacity": setFuelCapacity(value); break;
      case "propulsion": setPropulsion(value); break;
      case "generators": setGenerators(value); break;
      case "waterCapacity": setWaterCapacity(value); break;
      case "builder": setBuilder(value); break;
      case "keelLaid": setKeelLaid(value); break;
      case "bollardPull": setBollardPull(value); break;
      case "bhp": setBhp(value); break;
      case "trackable": setTrackable(value); break;
      case "numberOfPassengers": setNumberOfPassengers(value); break;
      default: break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Remove bollardPull if vessel type is not "AHTS 001" or "SEV 001"
    const formToSubmit = { ...changedFields };
    if (vesselType !== "AHTS 001" && vesselType !== "SEV 001") {
      delete formToSubmit.bollardPull;
    }

    // Only send the fields that have been changed
    if (Object.keys(formToSubmit).length > 0) {
      updateVesselInformation(
        {
          vesselId,
          updatedInfo: formToSubmit,
        },
        {
          onSuccess: () => toast.success("Vessel information updated successfully!"),
          onError: (error) => toast.error(`Error: ${error.message}`),
        }
      );
    } else {
      toast.info("No changes to update");
    }
  };

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };


  return (
    <div className="update-vessel-container">
  <div className="pri" onClick={() => toggleSection("vesselInformation")}>
    <p>Vessel Information</p>
    {collapsedSections.vesselInformation ? <IoIosArrowDown /> : <IoIosArrowUp />}
  </div>
  {!collapsedSections.vesselInformation && (
    <form onSubmit={handleSubmit}>
      <label>
        Number of Berths
        <input
          type="text"
          name="numberOfBerths"
          value={numberOfBerths}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Deck Space
        <input
          type="text"
          name="deckSpace"
          value={deckSpace}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Deck Strength
        <input
          type="text"
          name="deckStrength"
          value={deckStrength}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Classification
        <input
          type="text"
          name="classification"
          value={classification}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Year of Built
        <input
          type="text"
          name="yearOfBuilt"
          value={yearOfBuilt}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Speed
        <input
          type="text"
          name="speed"
          value={speed}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Port of Registry
        <input
          type="text"
          name="portOfRegistry"
          value={portOfRegistry}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Call Sign
        <input
          type="text"
          name="callSign"
          value={callSign}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Official Number
        <input
          type="text"
          name="officialNumber"
          value={officialNumber}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        IMO Number
        <input
          type="text"
          name="imoNumber"
          value={imoNumber}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        MMSI Number
        <input
          type="text"
          name="mmsiNumber"
          value={mmsiNumber}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Length Overall
        <input
          type="text"
          name="lengthOverall"
          value={lengthOverall}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Beam Moulded
        <input
          type="text"
          name="beamMoulded"
          value={beamMoulded}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Draft
        <input
          type="text"
          name="draft"
          value={draft}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Gross Tonnage
        <input
          type="text"
          name="grossTonnage"
          value={grossTonnage}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Cruising Speed
        <input
          type="text"
          name="cruisingSpeed"
          value={cruisingSpeed}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Range
        <input
          type="text"
          name="range"
          value={range}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Fuel Capacity
        <input
          type="text"
          name="fuelCapacity"
          value={fuelCapacity}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Propulsion
        <input
          type="text"
          name="propulsion"
          value={propulsion}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Generators
        <input
          type="text"
          name="generators"
          value={generators}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Water Capacity
        <input
          type="text"
          name="waterCapacity"
          value={waterCapacity}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Builder
        <input
          type="text"
          name="builder"
          value={builder}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Keel Laid
        <input
          type="text"
          name="keelLaid"
          value={keelLaid}
          onChange={handleChange}
          required
        />
      </label>
      {(vesselType === "AHTS 001") && (
            <label>
              Bollard Pull
              <input
                type="text"
                name="bollardPull"
                value={bollardPull}
                onChange={handleChange}
                required
              />
            </label>
          )}
      <label>
        BHP
        <input
          type="text"
          name="bhp"
          value={bhp}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Number of passenger
        <input
          type="text"
          name="numberOfPassengers"
          value={numberOfPassengers}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Trackable
        <select
          name="trackable"
          value={trackable}
          onChange={handleChange}
          required
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </label>
      <button type="submit" disabled={isUpdating}>
        {isUpdating ? "Updating..." : "Update Information"}
      </button>
    </form>
  )}
  <ToastContainer />
</div>

  );
};

export default UpdateVesselInformationForm;

